import { FC } from 'react';
import { useRecoilValue } from 'recoil';
import BootstrapButtonGroup from 'react-bootstrap/ButtonGroup';
import StarIcon from '@mui/icons-material/Star';
import ShareIcon from '@mui/icons-material/Share';
import HelpIcon from '@mui/icons-material/Help';

import * as K from 'common/constants';
import { HELP_ROUTE } from 'components/help/constants';
import ELEMENT from 'common/element';

import { TriggerType } from 'components/alerts/SaveAlertDialog';
import { currentChartRefState } from 'components/common/Graphs/graphs.state';
import { handleExport } from 'components/common/Graphs/ScalyrGraph';
import Button from 'components/common/Button/Button';
import Toolbar from 'components/common/Toolbar/Toolbar';
import { isCrossTeamSearchState, searchParamRecordState } from 'components/common/Managers/RouteStateManager.state';
import SearchActionsDropdown, { ActionMenuItemConfig, SearchActions } from 'components/search/SearchActionsDropdown';
import DistributionYScaleDropdown from 'components/search/DistributionPage/DistributionYScaleDropdown';

import './styles.scss';

const starIcon = <StarIcon fontSize="small" />;
const shareIcon = <ShareIcon fontSize="small" />;
const helpIcon = <HelpIcon fontSize="small" />;

const DistributionGraphResultsToolbar: FC = () => {
  const currentChartRef = useRecoilValue(currentChartRefState); // The ref to the current chart instance
  const searchParams = useRecoilValue(searchParamRecordState);
  const isCrossTeamSearch = useRecoilValue(isCrossTeamSearchState);

  const downloadGraphAsPNG = (): void => {
    const chart = currentChartRef?.current?.chart;
    if (chart) {
      let title = K.DEFAULT_EXPORT_GRAPH_TITLE;
      const subtitle =        !searchParams.facet && searchParams.breakdownFacet ? ` broken down by ${searchParams.breakdownFacet}` : '';
      title += subtitle;
      if (searchParams.facet) {
        title = `Graph of ${searchParams.facet}`;
      }

      handleExport(chart, title);
    }
  };
  const shareMenuSections = [[SearchActions.COPY_LINK], [SearchActions.SAVE_SHARED]];

  const dashAndAlertsSection: Array<string | ActionMenuItemConfig> = [];
  if (!isCrossTeamSearch) {
    dashAndAlertsSection.push(SearchActions.ALERT);
  }
  dashAndAlertsSection.push(SearchActions.DASHBOARD);
  const saveMenuSections: Array<Array<string | ActionMenuItemConfig>> = [
    [{ action: SearchActions.SAVE, text: 'Save Graph' }],
    dashAndAlertsSection,
  ];

  saveMenuSections.push([{ action: SearchActions.DOWNLOAD, text: 'Download as PNG', clickHandler: downloadGraphAsPNG }]);

  const saveAlertDialogConfig = {
    triggerType: TriggerType.FREQUENCY,
  };

  const group1 = (
    <BootstrapButtonGroup key="group1">
      <SearchActionsDropdown
        text="Save"
        leftIcon={starIcon}
        sections={saveMenuSections}
        saveAlertDialogConfig={saveAlertDialogConfig}
        testId={ELEMENT.searchDistribution}
        buttonTestId={ELEMENT.searchDistributionSaveButton}
      />
      <SearchActionsDropdown
        text="Share"
        leftIcon={shareIcon}
        sections={shareMenuSections}
        shouldFetchShortUrlAfterOpen
        testId={ELEMENT.searchDistribution}
        buttonTestId={ELEMENT.searchDistributionShareButton}
      />
    </BootstrapButtonGroup>
  );

  const leftItems = [ group1 ];
  const rightItems = [
    <DistributionYScaleDropdown />,
    <Button size="sm" leftIcon={helpIcon} href={HELP_ROUTE.HELP_GRAPHS_DISTRIBUTION} openInNewTab>
      Help
    </Button>,
  ];

  return (
    <div className="GraphResultsToolbar">
      <Toolbar leftItems={leftItems} rightItems={rightItems} />
    </div>
  );
};

export default DistributionGraphResultsToolbar;
